import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { HistoricoValorEmpresaList, ValorEmpresaList } from '../core/_models'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { empresaValoresColumns, empresaValoresHistoricoColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const EmpresaValoresTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { state } = useQueryRequest()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const colsValores = useMemo(() => empresaValoresColumns(t), [t])
  const colsHistorico = useMemo(() => empresaValoresHistoricoColumns(t), [t])
  const historico = state.tab === 'historico'

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum valor encontrado'
      description='Revise o tipo de atendimento ou a especialidade selecionada.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : historico ? (
    <TableEmptyState
      title='Nenhum valor no histórico'
      description='Ainda não há valores anteriores registrados.'
    />
  ) : (
    <TableEmptyState
      title='Nenhum valor cadastrado'
      description='Use “Novo valor” para cadastrar o primeiro valor.'
    />
  )

  const tableProps = {
    itemLabel: { singular: 'valor', plural: 'valores' },
    isLoading,
    isError,
    onRetry: refetch,
    emptyState,
    queryHooks: { useQueryRequest, useQueryResponse },
  }

  if (historico) {
    return (
      <CustomTable<HistoricoValorEmpresaList>
        {...tableProps}
        id='kt_table_empresas_historico_valores'
        ariaLabel='Histórico de valores'
        data={(response?.data as HistoricoValorEmpresaList[]) || []}
        columns={colsHistorico}
      />
    )
  }

  return (
    <CustomTable<ValorEmpresaList>
      {...tableProps}
      id='kt_table_empresas_valores'
      ariaLabel='Valores atuais'
      data={(response?.data as ValorEmpresaList[]) || []}
      columns={colsValores}
    />
  )
}
